import React from 'react';
import { Message } from '@naf/input';
import { FieldComponentTypes, FormField } from '@dtp/membership-service-types';
import { FieldError, UseFormReturn } from 'react-hook-form';
import { get } from '../../utils/safeGet';

interface FormFieldErrorMessageProps {
  field: FormField;
  fieldId: string;
  errors: UseFormReturn['formState']['errors'];
}

export const FormFieldErrorMessage = ({ field, fieldId, errors }: FormFieldErrorMessageProps) => {
  const error = get(errors, fieldId) as FieldError | undefined;
  if (!error || field.component === FieldComponentTypes.Radio) return null;

  const validationMessages = {
    required: field.validation?.required?.message,
    minLength: field.validation?.minLength?.message,
    maxLength: field.validation?.maxLength?.message,
    pattern: field.validation?.pattern?.message,
    min: field.validation?.min?.message,
    max: field.validation?.max?.message,
    manual: undefined,
  };
  if (!(error.type in validationMessages)) return null;
  const validationMessage = validationMessages[error.type as keyof typeof validationMessages];

  return <Message error>{validationMessage || error.message}</Message>;
};
